import { useState } from "react";
import { Send } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export const ContactForm = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contacts", {
        name: form.name,
        email: form.email || null,
        message: form.message,
      });
      window.location.href = "/thank-you?type=contact";
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Couldn't send your message — please call 480-940-6023.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="contact-section" className="mb-12 rounded-3xl border border-white/10 bg-white/5 p-6 backdrop-blur-sm sm:p-8">
      <div className="grid items-center gap-6 lg:grid-cols-[1fr_1.2fr]">
        <div className="text-center lg:text-left">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-amber-300">Say hello</p>
          <h2 className="mt-2 font-display text-xl font-extrabold text-white sm:text-2xl">
            Questions? Special care item? Just ask.
          </h2>
          <p className="mt-2 text-sm text-slate-400">
            A real person from our family answers every message — usually the same day.
          </p>
        </div>
        <form data-testid="contact-form" onSubmit={submit} className="grid gap-2.5 sm:grid-cols-2">
          <input
            data-testid="contact-name-input"
            required
            minLength={2}
            placeholder="Your name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="w-full rounded-xl border border-white/15 bg-white/10 px-4 py-3 text-sm font-semibold text-white placeholder:text-slate-500 focus:border-fall-amber focus:outline-none"
          />
          <input
            data-testid="contact-email-input"
            type="email"
            placeholder="Email (so we can reply)"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="w-full rounded-xl border border-white/15 bg-white/10 px-4 py-3 text-sm font-semibold text-white placeholder:text-slate-500 focus:border-fall-amber focus:outline-none"
          />
          <textarea
            data-testid="contact-message-input"
            required
            minLength={5}
            rows={3}
            placeholder="How can we help?"
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
            className="w-full rounded-xl border border-white/15 bg-white/10 px-4 py-3 text-sm font-semibold text-white placeholder:text-slate-500 focus:border-fall-amber focus:outline-none sm:col-span-2"
          />
          <button
            data-testid="contact-submit-button"
            type="submit"
            disabled={sending}
            className="flex items-center justify-center gap-2 rounded-xl bg-fall-amber px-6 py-3 font-display text-xs font-extrabold uppercase tracking-widest text-brand-navy shadow-lg transition-transform hover:scale-[1.02] disabled:opacity-60 sm:col-span-2"
          >
            <Send className="h-4 w-4" /> {sending ? "Sending…" : "Send message"}
          </button>
        </form>
      </div>
    </div>
  );
};
